import { render, staticRenderFns } from "./ArSummary.vue?vue&type=template&id=b9fd8846&scoped=true"
import script from "./ArSummary.vue?vue&type=script&lang=js"
export * from "./ArSummary.vue?vue&type=script&lang=js"
import style0 from "./ArSummary.vue?vue&type=style&index=0&id=b9fd8846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd8846",
  null
  
)

export default component.exports